import styled from '@emotion/styled';
import {LabelMedium} from '@travel-frontend/ui-components';

export const SponsoredBadge = styled(LabelMedium)`
  margin-bottom: 8px;
`;
